export const BANKING_ACTIVITY_SECTION_ID = 'banking-activity-section';
export const BANKING_ACTIVITY_SECTION_TITLE = 'Banking Activity Section';
